module.exports = __webpack_public_path__ + "img/slika25.81eb2dcd.jpg";